export function parseClerkError(err) {
	// TRY TO EXTRACT MEANINGFUL ERROR MESSAGE FROM CLERK ERROR SHAPE
	try {
		const clerkErrors =
			err?.errors?.map((e) => e?.message).filter((msg) => !!msg) || [];
		if (clerkErrors.length) return clerkErrors[0];

		if (err?.message) return String(err.message);

		return null;
	} catch {
		return null;
	}
}
